export const userRolesById = {
  1:"Cliente",
  2:"Admin",
  3:"API Permission"
}
